"use client";
import { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import BlogCard from "../BlogCard/BlogCard";
import Link from "next/link";
import ArrowRight from "@/public/icon/arrowRight.svg";

import "swiper/css/navigation";
import "swiper/css";
const BlogSection = ({ item, title, t }) => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  return (
    <div className="blogSection">
      <div className="subTitle">
        <span>{title}</span>
      </div>
      <div className="container">
        <Swiper
          spaceBetween={20}
          slidesPerView={3}
          breakpoints={{
            320: {
              slidesPerView: 1.5,
              spaceBetween: 16,
            },
            640: {
              slidesPerView: 2,
              spaceBetween: 16,
            },
            991: {
              slidesPerView: 3,
            },
          }}
        >
          {item
            ?.slice()
            .reverse()
            .map((blog) => (
              <SwiperSlide key={blog.id}>
                <BlogCard item={blog} />
              </SwiperSlide>
            ))}
        </Swiper>
      </div>
      <Link href="/news" className="moreLink">
        {t["TITLE.ALLNEWS"]}
        <ArrowRight />
      </Link>
    </div>
  );
};

export default BlogSection;
